import React, { Component } from 'react';
import { inject } from 'mobx-react';

@inject('authStore')
export default class ErrorMessage extends Component {
    render() {
        const { authStore } = this.props;
        return <div className="login-errors">
            {
                authStore.error &&
                <div>
                    {
                        authStore.error === 1 ?
                            <span>Virheellinen käyttäjätunnus/salasana</span> :
                            authStore.error === 2 ?
                                <span>Ota yhteyttä kirjanpitäjääsi tai Suonentiedon myyntiin käyttääksesi palvelua</span> :
                                authStore.error === 4 ? 
                                <span>Uusi salasana on liian lyhyt. Kirjoita vähintään 8 merkkiä pitkä salasana.</span> :
                                <span>Jokin meni vikaan</span>
                    }
                </div>
            }
        </div>
    }
}